import React, {useState} from 'react'
import {Button, Form, Modal, Input, message} from "antd";
import {getDepartmentById, updateDepartment} from "../../services/serviceDepartment";
import config from "../../config";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const { TextArea } = Input

const DepartmentEdit = ({deptId, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])

    const handleEditClick = () => {
        if (config.protectedVariables.departmentId.includes(deptId)){
            message.error('Bu işlem yapılamaz')
        }else {
            getDepartmentById(deptId)
                .then(({data}) => {
                    form.setFieldsValue({
                        deptName:  data.name,
                        deptCode: data.code,
                        deptDescription: data.description
                    })

                    setEditModal(!editModal)
                })
        }
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let request = {
            id: deptId,
            name: list.deptName,
            code: list.deptCode,
            description: list.deptDescription
        }
        updateDepartment(request)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    const formLayout = {
        labelCol: {span: 8},
        wrapperCol: {span: 16}
    }

    return(
        <React.Fragment>
            <Button  type={'link'} onClick={()=>handleEditClick()}>Güncelle</Button>

            <Modal
            open={editModal}
            closable={false}
            title={`Güncelle`}
            footer={[
                <Button type={'primary'} key={'SubmitButton'} loading={loadings[0]} onClick={()=> form.submit()}>Kaydet</Button>,
                <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'} >Kapat</Button>
            ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={()=>handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item

                        label={'Departman Adı'}
                        name={'deptName'}
                        rules={[
                            {required:true, message: 'Departman Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Departman Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input />

                    </Form.Item>
                    <Form.Item

                        label={'Departman Kodu'}
                        name={'deptCode'}
                        rules={[
                            {required: true, message: 'Departman Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Departman Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Departman Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Departman Açıklaması'}
                        name={'deptDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default DepartmentEdit